import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { Message } from '../../chatTypes';
import { WebSocketState } from '../websocketService';
import { useWebSocket } from '../hooks';

// Define context shape
interface WebSocketContextType {
    isConnected: boolean;
    connectionState: WebSocketState;
    error: Error | null;
    connect: () => Promise<void>;
    disconnect: () => void;
}

// Create context with default values
const WebSocketContext = createContext<WebSocketContextType>({
    isConnected: false,
    connectionState: WebSocketState.CLOSED,
    error: null,
    connect: async () => { },
    disconnect: () => { },
});

// Provider props
interface WebSocketProviderProps {
    userId: string;
    autoConnect?: boolean;
    onMessage?: (message: Message) => void;
    children: React.ReactNode;
}

// Provider component
export const WebSocketProvider: React.FC<WebSocketProviderProps> = ({
    userId,
    autoConnect = true,
    children,
}) => {
    // Use the WebSocket hook
    const {
        connectionState,
        isConnected,
        error,
        connect,
        disconnect,
    } = useWebSocket(userId, autoConnect);

    // Handle new messages and forward to callback
    // useEffect(() => {
    //     if (newMessages.length > 0 && onMessage) {
    //         // Process each new message
    //         newMessages.forEach(message => {
    //             onMessage(message);
    //         });
    //     }
    // }, [newMessages, onMessage]);

    // Create stable context value
    const contextValue = useMemo(() => ({
        isConnected,
        connectionState,
        error,
        connect,
        disconnect,
    }), [
        isConnected,
        connectionState,
        error,
        connect,
        disconnect,
    ]);

    return (
        <WebSocketContext.Provider value={contextValue}>
            {children}
        </WebSocketContext.Provider>
    );
};

// Custom hook to use WebSocket context
export const useWebSocketContext = () => useContext(WebSocketContext); 